import { render, staticRenderFns } from "./widgetPiePercentageChart.vue?vue&type=template&id=03d8edb3&scoped=true"
import script from "./widgetPiePercentageChart.vue?vue&type=script&lang=js"
export * from "./widgetPiePercentageChart.vue?vue&type=script&lang=js"
import style0 from "./widgetPiePercentageChart.vue?vue&type=style&index=0&id=03d8edb3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8edb3",
  null
  
)

export default component.exports